import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { SUPPORTED_LANGUAGES, Locale } from '../../locales';
import './LanguageToggle.css';

interface LanguageToggleProps {
  className?: string;
}

export const LanguageToggle: React.FC<LanguageToggleProps> = ({ className }) => {
  const { locale, setLocale } = useLanguage();

  return (
    <div
      className={className ? `qp-lang-switcher ${className}` : 'qp-lang-switcher'}
      role="group"
      aria-label="Выбор языка / Тілді таңдау / Language selection"
    >
      {SUPPORTED_LANGUAGES.map((lang) => {
        const isActive = locale === lang.code;
        return (
          <button
            key={lang.code}
            type="button"
            className={`qp-lang-btn ${isActive ? 'is-active' : ''}`}
            onClick={() => setLocale(lang.code as Locale)}
            aria-pressed={isActive}
            title={lang.label}
          >
            {lang.shortLabel}
          </button>
        );
      })}
    </div>
  );
};
